import intl from 'react-intl-universal';

interface FormattedMessageProps {
  id: string;
  values?: Record<string, any>;
  defaultMessage?: string;
}

export function FormattedMessage({ id, values }: FormattedMessageProps) {
  return <>{intl.get(id, values)}</>;
}

export function FormattedHTMLMessage({ ...args }: any) {
  return <>{intl.formatHTMLMessage({ ...args })}</>;
}

export const T = FormattedMessage;
